import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const FarewellEmbed: React.FC = () => {
  const navigate = useNavigate();
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const params = new URLSearchParams(search);
  const email = params.get('email') || '';
  const [loaded, setLoaded] = useState(false);

  const baseUrl = 'https://psi-mammoliti-farewell.lovable.app';
  const src = email ? `${baseUrl}?email=${encodeURIComponent(email)}` : baseUrl;

  return (
    <div style={{ minHeight: '100vh', background: '#463868', position: 'relative' }}>
      <button
        type="button"
        onClick={() => navigate('/profile', { state: { openTab: 'metrics' } })}
        style={{
          position: 'fixed',
          top: '4.5rem',
          left: '1rem',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.375rem',
          padding: '0.5rem 1rem',
          background: 'rgba(255,255,255,0.12)',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.25)',
          borderRadius: '9999px',
          fontSize: '0.875rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
          zIndex: 200,
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Volver
      </button>

      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0', position: 'relative' }}>
        {!loaded && (
          <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="skeleton-shimmer-dark" style={{ height: '2.5rem', borderRadius: '0.75rem', width: '60%' }} />
            <div className="skeleton-shimmer-dark" style={{ height: '1.25rem', borderRadius: '0.5rem', width: '80%' }} />
            <div className="skeleton-shimmer-dark" style={{ height: '1.25rem', borderRadius: '0.5rem', width: '70%' }} />
            <div className="skeleton-shimmer-dark" style={{ height: '1.25rem', borderRadius: '0.5rem', width: '50%' }} />
            <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div className="skeleton-shimmer-dark" style={{ height: '3rem', borderRadius: '0.75rem' }} />
              <div className="skeleton-shimmer-dark" style={{ height: '3rem', borderRadius: '0.75rem' }} />
              <div className="skeleton-shimmer-dark" style={{ height: '3rem', borderRadius: '0.75rem' }} />
            </div>
          </div>
        )}
        <iframe
          src={src}
          onLoad={() => setLoaded(true)}
          style={{
            display: loaded ? 'block' : 'none',
            width: '100%',
            height: '100vh',
            border: 0,
          }}
          title="Proceso de salida de Psi Mammoliti"
          allow="fullscreen; clipboard-read; clipboard-write"
        />
      </div>
    </div>
  );
};

export default FarewellEmbed;
